import React, { useEffect } from "react";
import { startBgm, stopBgm } from "@/lib/soundfx";

// Retro TV-console shell that wraps an arcade game inside a CRT screen with a joystick deck.
export const ConsoleFrame = ({ children }) => {
  useEffect(() => { startBgm(); return () => stopBgm(); }, []);
  return (
  <div data-testid="console-frame" className="mx-auto max-w-[440px] rounded-[22px] border-[4px] border-kirana-brown bg-gradient-to-b from-[#3b3b4c] to-[#20202a] p-3 hard-shadow">
    <div className="mb-2 flex items-center justify-between px-1">
      <span className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-[#a78bfa]">
        <span className="h-2 w-2 animate-pulse rounded-full bg-[#22c55e]" /> Power
      </span>
      <span className="font-signboard text-xs font-bold text-kirana-cream/80">NOSTALGIA&nbsp;64</span>
    </div>

    {/* CRT screen */}
    <div className="crt-glow relative overflow-hidden rounded-lg border-[3px] border-black bg-[#0a0a12] p-2">
      <div className="crt-scanlines crt-power-on relative z-[1]">{children}</div>
    </div>

    {/* console deck: joystick + action buttons (decorative) */}
    <div className="mt-3 flex items-center justify-between rounded-xl bg-black/30 px-4 py-2.5">
      <div className="relative h-11 w-12" aria-hidden>
        <div className="absolute bottom-0 left-1/2 h-4 w-9 -translate-x-1/2 rounded-full bg-black/60" />
        <div className="absolute bottom-2 left-1/2 h-6 w-2.5 -translate-x-1/2 rounded bg-[#8a5a2b]" />
        <div className="absolute bottom-7 left-1/2 h-4 w-4 -translate-x-1/2 rounded-full border-2 border-black bg-kirana-red" />
      </div>
      <span className="text-[10px] font-bold uppercase tracking-wide text-kirana-cream/50">▸ Insert Coin ◂</span>
      <div className="flex gap-2" aria-hidden>
        <span className="flex h-6 w-6 items-center justify-center rounded-full border-2 border-black bg-kirana-gold text-[10px] font-bold text-kirana-brown">A</span>
        <span className="flex h-6 w-6 items-center justify-center rounded-full border-2 border-black bg-kirana-green text-[10px] font-bold text-white">B</span>
      </div>
    </div>
    </div>
  );
};
